import { useState, useEffect } from 'react';
import { getSafeLocalStorage, setSafeLocalStorage } from './useSafeLocalStorage';

type ViewModeType = 'cards' | 'table';

interface ViewModePreferences {
  workforce?: ViewModeType;
  equipment?: ViewModeType;
  materials?: ViewModeType;
}

const STORAGE_KEY = 'rdo-view-preferences';

export const useViewModePersistence = () => {
  const [preferences, setPreferences] = useState<ViewModePreferences>({});

  // Load preferences from localStorage on mount
  useEffect(() => {
    const saved = getSafeLocalStorage<ViewModePreferences>(STORAGE_KEY, {});
    setPreferences(saved);
  }, []);

  // Save preferences to localStorage whenever they change
  const updatePreference = (section: keyof ViewModePreferences, mode: ViewModeType) => {
    const newPreferences = { ...preferences, [section]: mode };
    setPreferences(newPreferences);
    setSafeLocalStorage(STORAGE_KEY, newPreferences);
  };

  // Get preference for a section with fallback to default
  const getPreference = (section: keyof ViewModePreferences, defaultMode: ViewModeType = 'cards'): ViewModeType => {
    return preferences[section] || defaultMode;
  };

  return {
    getPreference,
    updatePreference,
  };
};